export default "__VITE_ASSET__DgYfjd0D__"